<template>
  <div class="asc-subscription-center-grid--wrapper">
    <div class="asc-subscription-center-grid--wrapper-gridTitle">
      {{ title }}
    </div>
    <div>
      <asc-ag-grid-filter
        class="asc-subscription-center-grid"
        :grid-options="agGridOptions"
        :column-defs="getGridColumnDefs"
        :row-data="values"
      ></asc-ag-grid-filter>
    </div>
  </div>
</template>

<script>
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'

import {
  AscAgGridFilter,
  AscLinkCellRenderer,
  AscSwitchCellRenderer,
} from '@/components/agGrid'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscSubscriptionCenterGridWrapper',

  components: { AscAgGridFilter, AscLinkCellRenderer, AscSwitchCellRenderer },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    values: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          floatingFilter: false,
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        suppressCellFocus: false,
        noRowsOverlayComponent: this.noOverlayComponent,
        onGridReady: this.handleGridReady,
        onGridSizeChanged: this.handleGridSizeChanged,
      }),
    }
  },

  computed: {
    getGridColumnDefs() {
      return [
        {
          headerName: this.getColumnTitle(this.gridColumns, 'active', 'Active'),
          field: 'isActive',
          maxWidth: 100,
          width: 90,
          suppressMovable: true,
          resizable: false,
          sortable: true,
          comparator: this.sortIsActiveColoumn,
          suppressSizeToFit: true,
          cellRenderer: 'AscSwitchCellRenderer',
          cellRendererParams: {
            valuefield: 'isActive',
            cellActiveHighlight: true,
            tooltipText: 'Fix all errors to activate custom analytic.',
            tooltipOnDisabledOnly: true,
            callback: arg => this.handleGridSwitchToggle(arg),
          },
          cellClass: ['ag-cell--flex', 'no-border-top-left'],
          sort: 'asc',
          sortingOrder: ['asc', 'desc'],
        },
        {
          headerName: this.getColumnTitle(this.gridColumns, 'name', 'Name'),
          field: 'name',
          flex: 1,
          suppressMovable: true,
          suppressSizeToFit: false,
          cellRenderer: 'AscLinkCellRenderer',
          sort: 'asc',
          sortable: true,
          sortingOrder: ['asc', 'desc'],
          cellRendererParams: {
            callback: arg => this.handleGridLinkClick(arg),
          },
        },
        {
          headerName: this.getColumnTitle(
            this.gridColumns,
            'frequency',
            'frequency',
          ),
          maxWidth: 185,
          width: 184,
          field: 'frequency',
          suppressMovable: true,
          suppressSizeToFit: false,
          valueFormatter: this.frequencyFormatter,
        },
      ]
    },
  },

  methods: {
    sortIsActiveColoumn(valueA, valueB, nodeA, nodeB) {
      if (valueA === valueB)
        return nodeA.data.name.localeCompare(nodeB.data.name)
      return valueB > valueA ? 1 : -1
    },
    handleGridSwitchToggle(val) {
      this.$emit('onSubscriptionActiveToggle', val)
    },
    handleGridLinkClick(val) {
      this.$emit('onSubscriptionEdit', val)
    },
    frequencyFormatter({ value }) {
      if (value && value.length) {
        const isSameFrequency = value.every(
          (frequency, i, arr) => frequency === arr[0],
        )

        if (isSameFrequency) {
          switch (value[0]) {
            case 1:
              return 'Immediate'
            case 2:
            case 3:
            default:
              return ''
          }
        } else {
          return 'Varied'
        }
      }

      return ''
    },
  },
}
</script>

<style lang="scss">
.asc-subscription-center-grid--wrapper {
  &-gridTitle {
    color: $primary-black;
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 18px;
    padding: 12px 7px 12px 7px;
    margin: 0;
    background-color: $gray-300;
    display: inline-block;
    width: 100%;
    border: 1px solid $primary-white;
    border-width: 1px 2px 0 1px;
    text-transform: uppercase;
  }

  .asc-subscription-center-grid {
    .ag-cell-link {
      a {
        color: $accent-700;
        text-decoration: none;
        text-transform: capitalize;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
